import {
  GET_SKINCONCERNS_STATED,
  GET_SKINCONCERNS,
  GET_SKINCONCERNS_ENDED,
  ADD_SKINCONCERN_STATED,
  ADD_SKINCONCERN,
  ADD_SKINCONCERN_ENDED,
  EDIT_SKINCONCERN_STATED,
  EDIT_SKINCONCERN,
  EDIT_SKINCONCERN_ENDED,
  GET_SKINCONCERN_STATED,
  GET_SKINCONCERN,
  GET_SKINCONCERN_ENDED,
  GET_ALL_SKINCONCERNS_STATED,
  GET_ALL_SKINCONCERNS,
  GET_ALL_SKINCONCERNS_ENDED
} from "../types/skinconcern_type";

const initialState = {
  skinconcerns_loading: true,
  skinconcerns: null,
  page: null,
  pages: null,
  total_skinconcerns: 0,

  skinconcern: null,
  skinconcern_loading: null,

  loading: true,

  skinconcern_message: null,
  all_skinconcerns: null,
  all_skinconcerns_loading: null,
  add_skinconcern_loading: true,
  edit_skinconcern_loading: true
};

export const skinconcern_reducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_SKINCONCERNS_STATED:
      return {
        ...state,
        skinconcerns: null,
        pages: null,
        page: null,
        total_skinconcerns: 0,
        skinconcerns_loading: true
      };
    case GET_SKINCONCERNS:
      return {
        ...state,
        skinconcerns: payload.skinconcerns,
        pages: payload.pages,
        page: payload.page,
        total_skinconcerns: payload.count
      };
    case GET_SKINCONCERNS_ENDED:
      return {
        ...state,
        skinconcerns_loading: false
      };
    case GET_ALL_SKINCONCERNS_STATED:
      return {
        ...state,
        all_skinconcerns_loading: true,
        all_skinconcerns: null
      };
    case GET_ALL_SKINCONCERNS:
      return {
        ...state,
        all_skinconcerns: payload
      };
    case GET_ALL_SKINCONCERNS_ENDED:
      return {
        ...state,
        all_skinconcerns_loading: false
      };

    case ADD_SKINCONCERN_STATED:
      return {
        ...state,
        skinconcern_message: null,
        add_skinconcern_loading: true
      };
    case ADD_SKINCONCERN:
      return {
        ...state,
        skinconcern_message: payload
      };
    case ADD_SKINCONCERN_ENDED:
      return {
        ...state,
        add_skinconcern_loading: false
      };
    case GET_SKINCONCERN_STATED:
      return {
        ...state,
        skinconcern: null,
        skinconcern_loading: true
      };
    case GET_SKINCONCERN:
      return {
        ...state,
        skinconcern: payload
      };
    case GET_SKINCONCERN_ENDED:
      return {
        ...state,
        skinconcern_loading: false
      };
    case EDIT_SKINCONCERN_STATED:
      return {
        ...state,
        skinconcern_message: null,
        edit_skinconcern_loading: true
      };
    case EDIT_SKINCONCERN:
      return {
        ...state,
        skinconcern_message: payload
      };
    case EDIT_SKINCONCERN_ENDED:
      return {
        ...state,
        edit_skinconcern_loading: false
      };

    default:
      return state;
  }
};
